import cn from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

import { RenderedProducts } from '../../store/products';
import styles from '../CategoriesAside/CategoriesAccordion.module.scss';

function OffersAside({ name, slugName }) {
  const [isActive, setIsActive] = useState(false);
  const router = useRouter();
  const { slug } = router.query;

  function onClickLink() {
    RenderedProducts.update({});
  }

  useEffect(() => {
    if ((slug && slug[0] === 'offers') || router.route.includes('/offers')) {
      setIsActive(true);
      return;
    }
    setIsActive(false);
  }, [slug]);

  return (
    <div>
      <div
        className={cn({
          [styles.containerSelected]: isActive,
          [styles.container]: !isActive,
        })}
      >
        <Link href={`/${slugName}`}>
          <a
            className={cn({
              [styles.categoriesSelected]: isActive,
              [styles.categories]: !isActive,
            })}
            onClick={onClickLink}
          >
            <div className={cn(styles[slugName], { [styles.isActiveCategory]: isActive })} />
            <span>{name}</span>
          </a>
        </Link>
      </div>
    </div>
  );
}

export default OffersAside;
